<template>
  <div class="information">
    <div class="container">
      <div class="logo-wrapper">
        <img
          class="logo"
          src="@/assets/home/guild-logo.png"
          alt="The Guild Hotel Logo - Tribute Portfolio"
        />
      </div>
      <Content />
    </div>
  </div>
</template>

<script>
import Content from "@/components/home/information/Content.vue";

export default {
  name: "Information",
  components: {
    Content
  }
};
</script>

<style lang="scss" scoped>
.information {
  // border: 1px solid blue;
  grid-area: information;
  padding: 2rem;
  z-index: 1;
}
.container {
  // border: 1px solid green;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 1rem;
  align-items: center;
}

@media screen and (max-width: 767px) {
  .information {
    padding: 0 0 1rem 0;
  }
  .container {
    padding: 0;
  }

  .logo {
    max-width: 100%;
    display: block;
  }
}
</style>
